module.exports = __webpack_public_path__ + "img/gb96-85_4.prt.d3889505.jpg";